import { Component, Inject, OnDestroy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ReplaySubject, Subject } from 'rxjs';

export interface ModalDialogData {
  color: string;
}

@Component({
  selector: 'app-modal-color-picker',
  templateUrl: './modal-color-picker.component.html',
  styleUrls: ['./modal-color-picker.component.scss'],
  standalone: false,
})
export class ModalColorPickerComponent implements OnDestroy {
  public closed: Subject<boolean> = new Subject<boolean>();
  private destroyed$ = new ReplaySubject<boolean>(1);
  public color = '';

  public constructor(
    @Inject(MAT_DIALOG_DATA) public data: ModalDialogData,
    public dialogRef: MatDialogRef<ModalColorPickerComponent>,
  ) {
    this.color = data.color;
  }

  public shouldCreateAccount(value: boolean): void {
    this.closed.next(value);
  }

  public ngOnDestroy(): void {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }

  public close(): void {
    this.dialogRef.close();
  }

  public pickColor(): void {
    this.dialogRef.close(this.color);
  }
}
